import { useContext } from 'react';
import { Button, Grid, Typography, Tooltip, Zoom } from '@mui/material';
import { toolContext } from '../ToolDetailsContext';
import { Link as RouterLink } from 'react-router-dom';
import moment from 'moment';
import SetAvailable from './SetAvailable';
import ToolUsers from './ToolUsers';
import ToolMaintenances from './ToolMaintenances';
import { applicationContext } from 'helpers/services';


let ToolForm = () => {
    let service = useContext(toolContext);
    let { toolTypologies } = useContext(applicationContext);


    return (
        <>
            <Grid container>
                <Grid item xs>
                    <Typography variant="h1">
                        {service.tool.serialNumber != null && service.tool.serialNumber !== ''
                            && <>{service.tool.serialNumber} - </>}
                        {service.tool.name}</Typography>
                </Grid>
                <Grid item xs />
                <Grid item>
                    <Tooltip TransitionComponent={Zoom} title="Modifica">
                        <Button
                            component={RouterLink}
                            to={{ pathname: `/tool/edit/${service.tool.toolId}` }}
                            variant="outlined"
                        >
                            Modifica Strumento
                        </Button>
                    </Tooltip>
                </Grid>
            </Grid>


            <Grid container style={{ marginTop: 8 }}>
                <ToolUsers />
                {toolTypologies.find(x => x.toolTypologyId === service.tool.toolTypologyId)?.needMaintenance === true &&
                    <ToolMaintenances />
                }
            </Grid>

            {service.selectedUserAvailable != null &&
                <SetAvailable
                    startDate={service.selectedUserAvailable.startDate}
                    onClose={(value: moment.Moment | null) => service.closeSetAvailable(value)}
                />
            }
        </>
    );
}

export default ToolForm;